import { Reveal } from "./Reveal";
import { SUMMARY, SUMMARY_DETAIL, INDUSTRIES, ERP_SYSTEMS, MODULE_PILLARS, TOOLS } from "../../data/content";

export const About = () => (
  <section id="about" data-testid="about-section" className="mx-auto max-w-[1500px] px-6 md:px-12 py-24 md:py-40">
    <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20">
      <div className="lg:col-span-3">
        <Reveal>
          <p className="overline text-terracotta">(01) — Profile</p>
          <p className="mt-6 font-grotesk text-2xl md:text-[1.75rem] font-semibold uppercase tracking-tight leading-[1.15] text-ink">
            Structure,
            <br />
            <span className="text-terracotta">creativity</span> &amp; a
            <br />
            strong work ethic.
          </p>
        </Reveal>
      </div>

      <div className="lg:col-span-9">
        <Reveal delay={0.1}>
          <p className="font-serif text-[1.6rem] leading-[1.3] md:text-[2.4rem] md:leading-[1.2] tracking-tight text-ink">
            {SUMMARY}
          </p>
          <div className="mt-7 space-y-5 max-w-3xl">
            {SUMMARY_DETAIL.map((p, i) => (
              <p key={i} className="text-sm md:text-base text-stone leading-relaxed font-light">
                {p}
              </p>
            ))}
          </div>
        </Reveal>

        <div className="mt-16 grid grid-cols-1 md:grid-cols-2 gap-12">
          <Reveal delay={0.15}>
            <p className="overline text-stone mb-5">Industries</p>
            <ul className="flex flex-wrap gap-2.5">
              {INDUSTRIES.map((i) => (
                <li
                  key={i}
                  className="rounded-full border border-line bg-paper px-4 py-2 text-sm text-ink hover:border-terracotta hover:text-terracotta transition-colors duration-300"
                >
                  {i}
                </li>
              ))}
            </ul>
          </Reveal>
          <Reveal delay={0.2}>
            <p className="overline text-stone mb-5">Systems &amp; Platforms</p>
            <ul className="flex flex-wrap gap-2.5">
              {ERP_SYSTEMS.map((i) => (
                <li
                  key={i}
                  className="rounded-full border border-line bg-paper px-4 py-2 text-sm text-ink hover:border-sage hover:text-sage transition-colors duration-300"
                >
                  {i}
                </li>
              ))}
            </ul>

            <p className="overline text-stone mb-5 mt-10">Module Pillars</p>
            <ul className="flex flex-wrap gap-2.5">
              {MODULE_PILLARS.map((i) => (
                <li
                  key={i}
                  className="rounded-full border border-terracotta/40 bg-terracotta/[0.06] px-4 py-2 text-sm text-ink hover:border-terracotta hover:text-terracotta transition-colors duration-300"
                >
                  {i}
                </li>
              ))}
            </ul>
            <p className="mt-4 font-serif italic text-lg text-stone">Across hundreds of topics.</p>
          </Reveal>
        </div>

        <Reveal delay={0.25} className="mt-14">
          <p className="overline text-stone mb-6">The Toolkit</p>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-px bg-line border border-line rounded-2xl overflow-hidden">
            {TOOLS.map((t) => (
              <div
                key={t}
                className="group bg-paper px-5 py-7 md:py-9 hover:bg-ink transition-colors duration-300"
              >
                <span className="font-serif text-lg md:text-xl text-ink group-hover:text-paper transition-colors duration-300 leading-tight block">
                  {t}
                </span>
              </div>
            ))}
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);
